import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  
  connect() {
    // Vérifie si cet accordéon est marqué comme actif par défaut
    if (this.element.classList.contains("active")) {
      this.open()
    } else {
      this.close()
    }
  }

  toggle(event) {
    event.preventDefault()

    if (this.element.classList.contains("active")) {
      this.close()
    } else {
      this.open()
    }
  }

  // Un lien réel (ex: "Ouvrir" vers la page module) peut se trouver imbriqué
  // dans la zone cliquable qui déclenche toggle(). Sans stopPropagation, le
  // clic bubble jusqu'au conteneur, qui appelle preventDefault() sur le MÊME
  // objet Event — annulant la navigation du lien (le clic "ouvre/ferme"
  // l'accordéon au lieu de suivre le lien). Cf. drawer_controller.js#stopPropagation
  // pour le même pattern.
  stopPropagation(event) {
    event.stopPropagation()
  }

  open() {
    this.element.classList.add("active")
    this.contentTarget.style.display = "block"
    this.iconTarget.style.transform = "rotate(0deg)"
  }
  
  close() {
    this.element.classList.remove("active")
    this.contentTarget.style.display = "none"
    this.iconTarget.style.transform = "rotate(-90deg)"
  }
}
